import { useState, useEffect } from 'react';
import { tagsMapFor } from '../../../data/tagAssignments';
import API from '../../../data/api';

/**
 * Loads the Client tags and a clientId → tags map so the "Etiquetas" column can be filtered.
 */
export function useClientTags(clients) {
    const [availableTags, setAvailableTags] = useState([]);
    const [clientTagsMap, setClientTagsMap] = useState({});

    useEffect(() => {
        const fetchTags = async () => {
            try {
                const api = API.Instance();
                const response = await api.requestTags({ modelType: 'Client' });
                const tags = response.tags || [];
                setAvailableTags(tags);

                // One request for every row's tags (data/tagAssignments.js)
                const tagsMap = await tagsMapFor(clients, 'Client', tags);
                setClientTagsMap(tagsMap);
            } catch (error) {
                console.error('Error fetching tags:', error);
            }
        };
        if (clients && clients.length > 0) {
            fetchTags();
        }
    }, [clients]);

    const hasTag = (clientId, tagId) => (clientTagsMap[clientId] || []).some((tag) => tag._id === tagId);

    return { availableTags, clientTagsMap, hasTag };
}
